import { ReactNode, useState } from 'react'
import React from 'react'
import { ConnectModalContext } from './context'

export function ConnectModalProvider({ children }: { children: ReactNode }) {
  const [isConnectModalOpen, setConnectModalOpen] = useState(false)
  return <ConnectModalContext.Provider value={{ isConnectModalOpen, setConnectModalOpen }} children={children} />
}
